import MainLayout from '../layout/main'

var indexRoutes = [
    { path: '/*', name: 'Main Layout', component: <MainLayout /> },
]

export default indexRoutes